<template>
  <div class="chinese-report">
    <!-- 文字說明 -->
    <section class="border-b border-b--dashed py-3">
      <h3 class="print-color subtitle-border mb-2">{{ $t('findings') }} :</h3>
      <div v-if="isColonReport">
        <ChineseReportFindingItems
          :chineseReportFindings="chineseReportFindings"
        />
      </div>

      <ul class="pl-3" v-else>
        <FindingsTypesLayout
          layoutTag="li"
          :name="gastro.type"
          :key="gastro.type"
          v-for="gastro in getChineseReport.orderedGastricData"
        >
          <template #content>
            <ChineseReportFindingItems
              :chineseReportFindings="modifyGastroData(gastro.data)"
            />
          </template>
        </FindingsTypesLayout>
      </ul>
    </section>

    <!-- border-b border-b--dashed -->
    <section class="py-3">
      <FindingItemImagesGroup
        :findings="chineseReportFindings"
        :additionImages="additionImages"
        :imgArrange="imgArrange"
        printBreakClass="break-inside-page"
      />
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FindingItemImagesGroup from './FindingItemImagesGroup.vue'
import ChineseReportFindingItems from './ChineseReportFindingItems.vue'
import FindingsTypesLayout from '@/components/commons/FindingsTypesLayout.vue'
import { PRINT_STATUS_YES } from '@/utils/examinations.config.js'

export default {
  name: 'ChineseReport',
  components: {
    FindingItemImagesGroup,
    FindingsTypesLayout,
    ChineseReportFindingItems,
  },
  props: {
    examinationID: String,
    imgArrange: Number,
    isColonReport: Boolean,
  },
  created() {
    this.fetchChineseReport({
      examinationID: Number(this.examinationID),
      language: 'zh-tw',
    })
  },
  computed: {
    ...mapGetters('report', ['getChineseReport']),
    getFindings() {
      return this.getChineseReport.findings
    },
    chineseReportFindings() {
      if (!this.getFindings) return []
      return Object.keys(this.getFindings).map((key) => ({
        ...this.getChineseReport.findings[key],
        id: key,
        images: this.getChineseReport.findings[key].images.map((img) => ({
          file: img,
          status: PRINT_STATUS_YES,
          examinationID: this.examinationID,
        })),
      }))
    },
    additionImages() {
      if (!Array.isArray(this.getChineseReport.additionalImages)) return
      return this.getChineseReport.additionalImages.map((img) => ({
        ...img,
        examinationID: this.examinationID,
      }))
    },
  },
  methods: {
    ...mapActions('report', ['fetchChineseReport']),
    modifyGastroData(gastro) {
      return gastro.map((g) => ({
        ...g,
        records: [{ ...g.records }].map((r) => ({
          處置: r['處置'] || null,
          其他處置: r['其他處置'] || null,
        })),
        cName: g.findingName.cName,
      }))
    },
  },
}
</script>
<style lang="scss" scoped>
ul,
li {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
</style>
